import React from "react";

const ContactThree = () => {
  return (
    <section className="contact_form_area contact_us section_padding">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="contact-right contact_details">
              <div className="hero-title-with-shape">
                <h4 className="heading_with_border">Contattaci</h4>
                <h1>Richiedi un preventivo gratuito</h1>
              </div>
              <p>
                <strong>ROUGE MULTISERVICE srl</strong>
              </p>
                <div className="contact_location_box">
                    <div className="contact_location_map">
                        <span className="icon-location"></span>
                        <p>
                            Via Caravaggio 3, <br />
                            Trezzano sul Naviglio - Milano
                        </p>
                    </div>
                    <div className="contact_location_map contact_location_call">
                        <span className="icon-contact_call"></span>
                        <p>
                            info@rougemultiservice.it <br />
                            +39 02 36706314
                        </p>
                    </div>
                </div>
                <p className="mt-5">
                    <strong>Orari</strong><br/>
                    Da lunedì a venerdì<br/>
                    dalle h 08:30 alle 12:30<br/>
                    dalle h 14:00 alle 18:00<br/>
                    <br/>
                    Sabato<br/>
                    dalle h 08:30 alle 12:30

                </p>

            </div>
          </div>
          <div className="col-md-6">
            <div className="contact-right contact-right-style-2 responsive_mt">
              <form action="/bin/send-contacts.php" method="post">
                <input
                  className="half_width input_m_right"
                  type="text"
                  name="name"
                  placeholder="Nome"
                />
                <input
                  className="half_width"
                  type="EMAIL"
                  name="email"
                  placeholder="Email"
                />
                <input type="tel" name="phone" placeholder="Telefono" />
                <textarea
                  name="message"
                  id="content"
                  cols="20"
                  rows="5"
                  placeholder="Messaggio"
                ></textarea>
                <button className="btn-yellow" value="INVIA">
                  INVIA
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactThree;
